<template>
  <div class="track_code_result">
    <el-dialog title="Хайлт" :visible.sync="this.$root.trackCodeDetailDialog" width="380px" :before-close="handleClose"
      center>
      <div class="track_code_area"> {{ searchItem }}</div>
      <div v-if="trackCodeDetailProp.length === 0">
        <img class="m-t-20" src="@/assets/images/search.jpeg"
          height="120px">
        <div
          class="no-wrap content_justify_center text_color font_format m-t-20">
          <span> Уучлаарай<br> дээрх кодтой бараа манай системд <br><span class="text_red"><b>бүртгэгдээгүй</b></span>
            байна. </span>
        </div><br>
    </div>
    <div v-else>
      <el-card v-for="item, index in this.trackCodeDetailProp" :key="index" class="m-b-10 br-20 m-t-10" shadow="always">
        <el-row>
          <el-col class="m-b-10">
            <h3 class="w-100">Трак:  {{ item.track_code }}
              <el-button @click="copyToClipboard(item.track_code)" type="text" :style="{ color: isCopied ? 'green' : 'black' }" :icon="isCopied === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
            </h3>
          </el-col>
          <el-col class="m-b-20">
            <el-tag class="no-wrap" v-if="item.progress_code === 100" type="primary"> {{ returnStatusValue(item.progress_code) }}</el-tag>
            <el-tag class="no-wrap" v-else-if="item.progress_code === 110" type="primary"> {{ returnStatusValue(item.progress_code) }}</el-tag>
            <el-tag class="no-wrap" v-else-if="item.progress_code === 120" type="success"> {{ returnStatusValue(item.progress_code) }}</el-tag>
            <el-tag class="no-wrap" v-else-if="item.progress_code === 130" type="warning"> {{ returnStatusValue(item.progress_code) }}</el-tag>
            <el-tag class="no-wrap" v-else-if="item.progress_code === 140" type="warning"> {{ returnStatusValue(item.progress_code) }}</el-tag>
            <el-tag class="no-wrap" v-else-if="item.progress_code === 150" type="warning"> {{ returnStatusValue(item.progress_code) }}</el-tag>
            <el-tag class="no-wrap" v-else-if="item.progress_code === 160" type="default"> {{ returnStatusValue(item.progress_code) }}</el-tag>
            <el-tag class="no-wrap" v-else-if="item.progress_code === 170" type="danger"> {{ returnStatusValue(item.progress_code) }}</el-tag>
            <el-tag class="no-wrap" v-else-if="item.progress_code === 200" type="success"> {{ returnStatusValue(item.progress_code) }}</el-tag>
          </el-col>
          <el-col class="m-b-10">
            <span> {{ item.progress_created_at.split('T')[0] }}</span>
          </el-col>
          <el-col>
            <span> Төлбөр: {{ item.price | formatCurrency() }}</span>
          </el-col>
          <!-- <el-col class="m-t-10">
            <el-button @click="viewOrderDetail(item)" type="primary" class="font_format w-100 br-20" size="small">Захиалгийн дэлгэрэнгүй</el-button>
          </el-col> -->
        </el-row>
      </el-card>
    </div>
    </el-dialog>
    <OrderDetailDialog v-if="this.$root.orderDetailDialog" :orderDetailProp="selectedOrder"/>
    <LoginDialog v-if="true"></LoginDialog>
  </div>
</template>

<script>
import OrderDetailDialog from './orderDetailDialog.vue'
import LoginDialog from './loginDialog.vue'
import {
  mapGetters
} from 'vuex'
import services from '@/helpers/services'

export default {
  props: {
    trackCodeDetailProp: Array,
    searchItem: String
  },
  data () {
    return {
      customObject: {},
      selectedOrder: {},
      isCopied: false
    }
  },
  computed: {
    ...mapGetters([
      'idTokenGetter'
    ])
  },
  components: {
    // Barcode,
    OrderDetailDialog,
    LoginDialog
  },
  created () {
    this.objectReplace()
  },
  methods: {
    async copyToClipboard (text) {
      try {
        await navigator.clipboard.writeText(text)
        this.isCopied = true
        setTimeout(() => {
          this.isCopied = false
        }, 1000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    objectReplace () {
      this.$root.statusArray.forEach(element => {
        if (this.trackCodeDetailProp.progress_code === element.value) {
          this.customObject = element
        }
      })
    },
    handleClose () {
      this.$root.trackCodeDetailDialog = false
    },
    trackCodeAddView () {
      this.$root.trackCodeDetailDialog = false
      this.$root.trackCodeAddDialog = true
    },
    viewOrderDetail (data) {
      if (!this.idTokenGetter) {
        this.$alert('Та нэвтэрч захиалгийн дэлгэрэнгүйг харна уу.', 'НЭВТРЭХ', {
          confirmButtonText: 'Нэвтрэх',
          callback: action => {
            this.$root.loginDialog = true
          }
        })
      } else {
        this.$root.fullscreenLoading = true
        const response = services.getTrackCodeById(data.id)
        if (response) {
          this.selectedOrder = response.data
          this.$root.orderDetailDialog = true
          this.$root.fullscreenLoading = false
        }
      }
    },
    returnStatusValue (data) {
      const result = this.$root.statusArray.find(element => element.value === data)
      if (result) {
        return result.label
      } else {
        return 'empty'
      }
    }
  }
}

</script>

<style>
.track_code_area {
  background-color: #D9D9D9;
  font-size: 36px;
  font-weight: bold;
  color: rgb(0, 0, 0);
  padding: 8px;
  font-family: 'Geologica', sans-serif;
}

.track_code_result {
  text-align-last: center;
  font-weight: 18px;
  font-family: 'Geologica', sans-serif;
}
</style>
